import React from "react";
import styled from "styled-components";

/**
 * Loading screen for Add to Cart
 *
 * @returns {Object}
 */
export default function LoadingSpinner() {
  return (
    <LoadingButtonContainer>
      <LoadingButton>
        Processing image, this could take a second...
      </LoadingButton>
    </LoadingButtonContainer>
  );
}

const LoadingButtonContainer= styled.div`
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  background-color: #4d4d4d;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  opacity: 0.8;
  z-index: 999;
`;
const LoadingButton = styled.p`
  position: absolute;
  text-align: center;
  top: 50%;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: normal;
  color: #fff;
  font-size: 20px;
  font-weight: 300;
`;
